import React from 'react'
import { ThemeProvider as ProviderStyledComponents } from 'styled-components'

import theme from 'styles/theme'
import { useLocation } from 'hooks'

const ThemeProvider = ({ children }) => {
  const { isCreators } = useLocation()

  const isLight = isCreators
  const currentTheme = isLight ? theme.light : theme.dark

  return (
    <ProviderStyledComponents theme={currentTheme}>
      {children}
    </ProviderStyledComponents>
  )
}

export default ThemeProvider
